module.exports = __webpack_public_path__ + "static/img/tooltip-constellation-time-between-reverse-link-arrivals.7119277.png";